import React from "react"
import Button from "../../../shared/components/atoms/button/button"
import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal"
import { siteUrl } from "../../../shared/utils/siteUrl"
import "./modal-phone-recovery.scss"

const ModalPhoneRecovery = props => {
  var homeLink = siteUrl + "/"

  const homeRedirect = () => {
    window.location.href = siteUrl + "/"
  }

  return (
    <GenericModal>
      <div className="f-modal-info">
        <div className="f-main-title-container">
          <label className="f-main-title">¡Revisa tu celular!</label>
        </div>
        <div className="f-description-container">
          <p className="f-description">
            Te hemos enviado una clave temporal para que ingreses a tu cuenta y
            puedas actualizarla.
          </p>
        </div>
        <div className="f-btn-container">
          <div className="f-btn-interaction-container" onClick={homeRedirect}>
            <Button title="Entendido" className="new-primary-pink short" />
          </div>
        </div>
      </div>

      <a href={homeLink}>
        <span className="icon2-close f-icon f-close-icon" />
      </a>
    </GenericModal>
  )
}

export default ModalPhoneRecovery
